module.exports = __webpack_public_path__ + "img/5851e2ce132b57105a78ce114fae76a.6e310a8a.jpg";